import { Button, Select, Layout, theme, Form, notification, Row, Col } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import UserApi from "../../common/Apis/UserApi";
import Sidebar from "../../common/Sidebar/Sidebar";
import TopHeader from "../../common/TopHeader/TopHeader";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import RoleApi from "../../common/Apis/RoleApi";

const { Content } = Layout;
const CreateUser = () => {
  let navigate = useNavigate();
  const [UserEmails, setUserEmails] = useState();
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleChange = (value) => {
    setUserEmails(value);
    console.log(value);
  };
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const handleSubmit = (data) => {
    if (decodedToken.tenantId) {
      let formData = JSON.stringify({
        emailList: UserEmails,
        roleDTO: RoleDetails,
        tenantDTO: {
          id: decodedToken.tenantId,
        },
      });

      console.log(formData);
      // send Aptitude Test Api
      UserApi.sendAptitudeTest(formData)
        .then((response) => {
          console.log(response);
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>Aptitude Test Sent</span>
            ),
            description: "Please check your inbox",
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#b3ffb3",
              color: "green",
            },
          });
          return navigate("/users");
        })
        .catch((err) => {
          // Error Notification
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        });
    }
  };

  const [AllRoles, setAllRoles] = React.useState([]);
  const getAllRoles = useCallback(() => {
    RoleApi.ListAllRoles()
      .then((response) => {
        setAllRoles(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  useEffect(() => {
    getAllRoles();
  }, [getAllRoles]);

  const validateEmail = (rule, value, callback) => {
    // Check if the entered value is a valid email address
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = value.every(email => emailRegex.test(email.trim()));

    if (!isValidEmail) {
      callback('Please enter valid email addresses.');
    } else {
      callback();
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };
  const [RoleDetails, setRoleDetails] = useState(null);

  const handleChangeRole = (value) => {
    RoleApi.SingleRole(value).then((response) => {
      console.log(response)
      setRoleDetails(response?.payload)
    })
      .catch((err) => {
        console.log(err);

      });
    console.log(value)

  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form name="nest-messages"
            className="FormClass" layout="vertical" onFinish={handleSubmit}>
            <>
              <Row gutter={16}>
                <Col span={15}>
                  <Form.Item
                    name="email"
                    label="Email"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Email must include only alphabet characters.",
                      },
                      { validator: validateEmail }
                    ]}
                  >
                    <Select
                      mode="tags"
                      onChange={handleChange}
                      className="select-multi"
                      tokenSeparators={[","]}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="RolesId"
                    label="Roles :"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Roles.",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => handleChangeRole(value)}
                      placeholder="Select Roles"
                    >
                      {(decodedToken?.roles?.includes("TENANT_ADMIN") || ("SUPER_ADMIN")) ? <>
                        <option value={2}>
                          Syatem User
                        </option>
                        
                        {/* <option value={4}>
                          Sub Tenant Admin
                        </option>
                        <option value={5}>
                          Sub Tenant User
                        </option> */}
                      </>
                        :
                        <>
                          {AllRoles && (
                            <>
                              {AllRoles?.map((option, index) => (
                                <option key={index} value={option?.id}>
                                  {option?.name}
                                </option>
                              ))}
                            </>
                          )}

                        </>
                      }
                      

                    </Select>
                  </Form.Item>
                </Col>

              </Row>

              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Send
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default CreateUser;
